var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentGatewayIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "PaymentGatewayIcon",
    d: "M15,8H10a3,3,0,0,1,0,6H9l3,3M9,11h6M3,12a9,9,0,1,0,.685-3.444A9,9,0,0,0,3,12Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentGatewayIconDark);
export default __webpack_public_path__ + "static/media/PaymentGatewayIconDark.4a6dbb9ec629cb1b9e712be73966f926.svg";
export { ForwardRef as ReactComponent };